import { useQuery } from '@apollo/react-hooks';
import { ME_CLIENT } from 'gql';

export const useCheckLogin = () => {
  const { data: dataMeClient } = useQuery(ME_CLIENT);
  const meClient = { ...dataMeClient.meClient };
  return !!meClient.email;
};
